import { Button, Modal } from 'antd';
import { t } from 'i18next';
import {
    IconStatusOff,
    IconStatusOn,
} from '../../../assets/Images/icons/icon-status';

const ModalStatus = ({
    open,
    text = 'Lorem ipsum dolor sit amet',
    handelClose,
    handelOk,
    loading,
    on = true,
}) => {
    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6">
                {!on ? <IconStatusOn /> : <IconStatusOff />}
                <div className="text-2xl font-semibold">
                    {!on ? t('common.TurnonStatus') : t('common.TurnoffStatus')}
                </div>
                <div>{text}</div>
            </div>
            <div className="flex justify-center items-center space-x-4">
                <Button type="primary" onClick={handelClose} size="large" ghost>
                    {t('common.Cancel')}
                </Button>

                <Button
                    loading={loading}
                    onClick={handelOk}
                    size="large"
                    type="primary"
                >
                    {t('common.Confirm')}
                </Button>
            </div>
        </Modal>
    );
};
export default ModalStatus;
